import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FlowManagerService } from '../../services/flow-manager.service';
import { swalMini, swalWarning } from '../../../../shared/utils/utils';
import { Observable } from 'rxjs';
import filter from 'lodash/filter';
import { map } from 'rxjs/operators';
import { SharedService } from '../../../../core/services/store/shared-store/shared-storage.service';
import { MatFormField } from '@angular/material/form-field';
import {ToastBannerService} from "../../../../shared/components/cms/toast-banner/toast-banner.service";
import {MatAutocompleteTrigger} from "@angular/material/autocomplete";

@Component({
  selector: 'app-move-flow',
  templateUrl: './move-flow.component.html',
  styleUrls: ['./move-flow.component.scss'],
})
export class MoveFlowComponent implements OnInit {
  flowId: any;
  title: any;
  newPath: any;
  requestFlowLoad: string;
  requestRouteLoad: string;
  filteredFlows: Observable<Array<any>>;
  savingInProgress: Boolean = false;
  flowName: string;

  @ViewChild('flowPathInput') flowPathInput: MatFormField;
  @ViewChild('selectArrow') selectArrow: ElementRef;
  @ViewChild('flowsAuto') flowsAuto: MatAutocompleteTrigger;

  constructor(
    public dialogRef: MatDialogRef<MoveFlowComponent>,
    private flowManagerService: FlowManagerService,
    private sharedService: SharedService,
    private toastService: ToastBannerService
  ) {}

  ngOnInit() {
    this.flowId = this.dialogRef._containerInstance._config.data.flowId;
    this.newPath = this.dialogRef._containerInstance._config.data.path;
    this.flowName = this.dialogRef._containerInstance._config.data.flowName;
    this.title = this.dialogRef._containerInstance._config.data.flowName;
    this.filteredFlows = this.flowManagerService.getFlows(false);
  }

  filterPaths(value: String): void {
    this.filteredFlows = this.flowManagerService.getFlows(false).pipe(
      map((flows) => {
        // return flow.path.toLowerCase().includes(value.toLowerCase());
        return filter(flows, (flow) => {
          return flow.path.toLowerCase().includes(value.toLowerCase());
        });
      })
    );
  }

  saveFlow() {
    this.moveFlow();
  }

  moveFlow() {
    const stageRequest = {
      flowId: this.flowId,
      flowPath: this.newPath,
    };

    const sameName = this.sharedService.checkSameFlowName('move', {
      flowPath: this.newPath + this.title,
    });
    if (sameName) {
      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `Flow with same name already exist!`,
          ``,
          false,
          true
      );
      return;
    }

    this.savingInProgress = true;
    this.flowManagerService.moveFlow(stageRequest).subscribe((response) => {
      this.savingInProgress = false;
      this.dialogRef.close();
      if (response.result === true) {
        this.displayBanner(
            '#8cc63f',
            'redesign/Check_Mark_Filled.svg',
            `Flow moved.`,
            ``,
            false,
            true
        );
        this.flowManagerService.getFlows(true).subscribe((flows) => {
          this.sharedService.updateFlows(flows);
        });
        return;
      }
      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `Failed to move flow!`,
          ``,
          false,
          true
      );
    }, (response) => {
      this.displayBanner(
          '#F8BD32',
          'redesign/ExclamationMark.svg',
          `Failed to move flow!`,
          `${response.error.message}`,
          false,
          true
      );
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  getErrorMessage() {
    return 'Enter folder name with /';
  }

  isValidPath(): boolean {
    return !(
      this.newPath.length === 0 ||
      (this.newPath.charAt(this.newPath.length - 1) === '/' && this.newPath.length >= 2)
    );
  }

  displayBanner(lineColor: string, icon: string, title: string, descrip: string, bigIcon: boolean, closeIcon: boolean): void {
    this.toastService.setBannerParams({ lineColor, icon, title, descrip, bigIcon, closeIcon });
    setTimeout(() => {
      this.toastService.clearBannerParams();
    }, 5000);
  }

  rotateArrow() {
    if (
        this.selectArrow.nativeElement.style.transform === '' ||
        this.selectArrow.nativeElement.style.transform === 'rotate(0deg) translateY(2px)'
    ) {
      this.flowPathInput._elementRef.nativeElement.style.border = '1px solid #2cc4ec';
      this.selectArrow.nativeElement.style.transform = 'rotate(180deg) translateY(0px)';
    } else {
      this.flowPathInput._elementRef.nativeElement.style.border = '1px solid #d4d9e2';
      this.selectArrow.nativeElement.style.transform = 'rotate(0) translateY(2px)';
    }
  }
}
